import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';

import { InputTextComponent } from '@shared/component/input/input-text/input-text.component';
import { InputDropdownComponent } from '@shared/component/input/input-dropdown/input-dropdown.component';
import { DemoService } from 'src/app/core/service/demo.service';
import { AnalyticsService } from '@core/service/analytics.service';

@Component({
  selector: 'app-demo-modal',
  imports: [CommonModule, RouterLink, ReactiveFormsModule, InputTextComponent, InputDropdownComponent],
  templateUrl: './demo-modal.component.html',
})
export class DemoModalComponent {
  form: FormGroup;
  sending = false;
  sent = false;

  protected readonly roleOptions: SelectItem[] = [
    { label: 'Propietario', value: 'propietario' },
    { label: 'Consejo de admin.', value: 'consejo' },
    { label: 'Residente', value: 'residente' },
    { label: 'Administrador', value: 'administrador' },
  ];

  constructor(
    private readonly fb: FormBuilder,
    readonly demoService: DemoService,
    private readonly analytics: AnalyticsService
  ) {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      phone: ['', [Validators.required, Validators.pattern(/^[0-9+\s\-()]{7,15}$/)]],
      email: ['', [Validators.required, Validators.email]],
      city: ['', [Validators.required, Validators.minLength(2)]],
      role: ['', Validators.required],
    });
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.close();
  }

  close(): void {
    this.demoService.close();
    this.sending = false;
    this.sent = false;
    this.form.reset();
  }

  submit(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      const invalidFields = Object.keys(this.form.controls).filter(key => this.form.get(key)?.invalid);
      this.analytics.trackEvent('demo_form_error', { fields: invalidFields.join(',') });
      return;
    }

    this.sending = true;
    // Simular envío — se integrará con el backend
    setTimeout(() => {
      this.sending = false;
      this.sent = true;
      this.analytics.trackEvent('generate_lead', {
        role: this.form.value.role,
        source: this.demoService.source(),
      });
    }, 1200);
  }
}
